import { Injectable } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
    providedIn: 'root'
  })
  export class ValidationService {
    constructor(private translate: TranslateService) {}
  
   public getValidationErrorMessage(control: AbstractControl): string | null {
      if (!control.errors) return null;
  
      if (control.errors.required) return this.translate.instant('errors.required');
      if (control.errors.email) return this.translate.instant('errors.email');
      if (control.errors.minlength) return this.translate.instant('errors.min_length', { length: control.errors.minlength.requiredLength });
      if (control.errors.maxlength) return this.translate.instant('errors.max_length', { length: control.errors.maxlength.requiredLength });
      if (control.errors.pattern) return this.translate.instant('errors.invalid_field');
      if (control.errors.phoneNumberInvalid) return this.translate.instant('errors.invalid_phone');
      if (control.errors.invalidImage) return this.translate.instant('errors.invalid_image');
      
      // ... Add more error checks as needed
  
      return 'defaultError';
    }
  }
  
